export default __webpack_public_path__ + "static/media/Transfer_Icon.2ff91634.svg";